import { HttpClient } from '@angular/common/http';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { environment } from "../../environments/environment";
import { map, Observable } from 'rxjs';
import { Buffer } from 'buffer';

export interface IUserStatistics {
  verified_users: number,
  unverified_users: number,
  total_users: number,
  key_account_users: number,
  active_users: number
}

@Pipe({
  name: 'tenantUserStatistics',
  standalone: true
})
export class TenantUserStatisticsPipe implements PipeTransform {
  http = inject(HttpClient)

  // transform(customerId: string, employees: number): Observable<IUserStatistics> {
  //   let identity = Buffer.from(customerId).toString('base64')
  //   return this.http.get<IUserStatistics>(`${environment.yomaApiURL}/customers/${identity}/users/statistics`)
      // .pipe(
      // map(res => {
      //   return employees ? `${res.verified_users} vs. [ ${employees} ] = ${Math.round(res.verified_users / employees * 100)}%` : `${res.verified_users} vs. [ ... ] = ..... %`;
      // })
    // );
  // }

  transform(customerId: string): Observable<IUserStatistics> {
    const identity = Buffer.from(customerId).toString('base64');
    return this.http.get<IUserStatistics>(
      `${environment.yomaApiURL}/customers/${identity}/users/statistics`
    );
  }
}
